// The API's error message (e.g. a rubric family conflict), or the fallback.
export function apiErrorDetail(error: unknown, fallback: string): string {
  return (
    (error as { errors?: { detail?: string }[] } | null)?.errors?.[0]?.detail ||
    fallback
  );
}
